import {Notification} from "./Notification";
import {NotificationAdapter} from "./NotificationAdapter";

interface NotificationGroup {
	title: string;
	message: string;
}

interface ErrorItem {
	message: string;
	errors: ErrorItem[];
}

export interface ErrorGroup {
	propertyName?: string;
	message: string;
	errors: ErrorItem[];
}

export class MultiErrorMessageNotification extends Notification {
	private _notificationAdapter: NotificationAdapter;
	private _notifications: NotificationGroup[];

	constructor(notificationAdapter: NotificationAdapter, errorResponse: ErrorGroup[]) {
		super();
		this._notificationAdapter = notificationAdapter;
		this._notifications = [];

		errorResponse.forEach((errorGroup, index) => {
			let notificationGroup: Partial<NotificationGroup> = {};

			let containsMultipleErrors =
				errorGroup.errors.length > 1 ||
				(errorGroup.errors.length === 1 && errorGroup.errors[0].errors.length > 1);
			notificationGroup.title = errorGroup.propertyName
				? `${errorGroup.propertyName} ${containsMultipleErrors ? "Errors" : "Error"}`
				: "";

			let message = "<ul>";
			let messageAsTitle = "";
			if (containsMultipleErrors) {
				if (errorGroup.message !== "") messageAsTitle = errorGroup.message;

				errorGroup.errors.forEach((item: Record<string, any>) => {
					if (item.errors.length > 0)
						item.errors.forEach((subItem: Record<string, any>) => (message += `<li>${subItem.message}</li>`));
					else message += `<li>${item.message}</li>`;
				});
			} else message += `<li>${errorGroup.message}</li>`;

			message += "</ul>";

			if (notificationGroup.title === "")
				notificationGroup.title = messageAsTitle !== "" ? messageAsTitle : `Error ${index + 1}`;

			notificationGroup.message = message;

			this._notifications.push(notificationGroup as NotificationGroup);
		});
	}

	notify(): void {
		this._notifications.forEach((notification: Record<string, any>) =>
			this._notificationAdapter.error(notification.message, notification.title),
		);
	}
}
